<template>
  <div>
    <ai-report-quarter-container />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import AiReportQuarterContainer from "@/containers/ai-report/AiReportQuarterContainer.vue";

export default defineComponent({
  components: { AiReportQuarterContainer },
});
</script>
